__turbopack_context__.v({
  "input": "text-module__JRg_EG__input",
  "input_cmp_form": "text-module__JRg_EG__input_cmp_form",
});
